// extracted by mini-css-extract-plugin
module.exports = {"modal":"FeedModal_modal__33mZ7","modalInterno":"FeedModal_modalInterno__lJs7P"};